import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { PaymentAccount } from '@uzurv/clara';
import * as OrganizationRiderActions from '../../../../store/organization-rider/organization-rider.actions';
import * as OrganizationRiderSelectors from '../../../../store/organization-rider/organization-rider.selectors';
import { AbstractPaymentAccountFormData } from '../../../forms/payment-account/abstract-payment-account-form';
import { OrganizationRiderPaymentAccountFormComponent } from '../../../forms/payment-account/organization-rider-payment-account/organization-rider-payment-account-form.component';

@Component({
  selector: 'app-organization-rider-payment-account-dialog',
  templateUrl: './organization-rider-payment-account-dialog.dialog.html',
  styleUrls: ['./organization-rider-payment-account-dialog.dialog.scss'],
  standalone: true,
  imports: [AsyncPipe, OrganizationRiderPaymentAccountFormComponent]
})
export class OrganizationRiderPaymentAccountDialog {
  readonly store$ = inject(Store);
  readonly data = inject<AbstractPaymentAccountFormData>(MAT_DIALOG_DATA);
  readonly dialogRef = inject<MatDialogRef<OrganizationRiderPaymentAccountDialog>>(MatDialogRef);

  submittingPaymentAccount$ = this.store$.select(OrganizationRiderSelectors.getSubmittingPaymentAccount);

  handleCreatePaymentAccount(paymentAccount: PaymentAccount): void {
    this.store$.dispatch(OrganizationRiderActions.CreatePaymentAccount({ payload: { dialogRef: this.dialogRef, paymentAccount } }));
  }

  handleUpdatePaymentAccount(paymentAccount: PaymentAccount): void {
    this.store$.dispatch(OrganizationRiderActions.EditPaymentAccount({ payload: { dialogRef: this.dialogRef, paymentAccount } }));
  }

  handleDeletePaymentAccount(): void {
    this.store$.dispatch(
      OrganizationRiderActions.DeletePaymentAccount({ payload: { dialogRef: this.dialogRef, paymentAccount: this.data.paymentAccount } })
    );
  }
}
